import { render, staticRenderFns } from "./MpAppIntroduction.vue?vue&type=template&id=9fd84502&scoped=true&"
import script from "./MpAppIntroduction.vue?vue&type=script&lang=js&"
export * from "./MpAppIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./MpAppIntroduction.vue?vue&type=style&index=0&id=9fd84502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd84502",
  null
  
)

export default component.exports